import { k as a, v as u } from "./cage-B9sdzDdT.js";
import { T as r } from "./index-rfWRAczx.js";
import { createRequire as y } from "module";
import { g as d } from "./utils-S4B18cwO.js";
const b = y(import.meta.url), P = b("isolated-vm"), h = (i, n) => a(
  r.tryCatch(
    async () => {
      const e = new P.Isolate(), o = await e.createContext();
      return { isolate: e, context: o };
    },
    (e) => `Context initialization failed: ${e}`
  ),
  r.chain(
    ({ isolate: e, context: o }) => a(
      r.tryCatch(
        async () => {
          const t = o.global, { pw: s, updatedEnvs: p } = u(n), c = d(s);
          t.setSync("serializedAPIMethods", c, {
            copy: !0
          }), t.setSync("atob", atob), t.setSync("btoa", btoa);
          const l = `
                const pw = new Proxy(serializedAPIMethods, {
                  get: (pwObjTarget, pwObjProp) => {
                    const topLevelEntry = pwObjTarget[pwObjProp]
                    // "pw.env" set of API methods
                      if (topLevelEntry && typeof topLevelEntry === "object") {
                        return new Proxy(topLevelEntry, {
                          get: (subTarget, subProp) => {
                            const subLevelProperty = subTarget[subProp]
                            if (subLevelProperty && subLevelProperty.typeof === "function") {
                              return (...args) => subLevelProperty.applySync(null, args)
                            }
                          },
                        })
                      }
                  }
                })
                ${i}
              `;
          return await (await e.compileScript(l)).run(o), { updatedEnvs: p, updatedCookies: null };
        },
        (t) => t
      ),
      r.fold(
        (t) => r.left(`Script execution failed: ${t}`),
        (t) => a(
          r.tryCatch(
            async () => (await e.dispose(), t),
            (s) => `Isolate disposal failed: ${s}`
          )
        )
      )
    )
  )
);
export {
  h as runPreRequestScriptWithIsolatedVm
};
